import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/SwitchModePowerSupplyESPHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-38.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .smps { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .smps-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .smps-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .smps-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .smps-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .smps-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 627px;
  }
  .smps-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .smps-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .smps-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .smps-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .smps-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .smps-bc-item:hover { color: #EB2019; }
  .smps-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .smps-bc-sep img { width: 24px; height: 24px; display: block; }
  .smps-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .smps-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .smps-main-section { padding: 80px 0 120px 0; }
  .smps-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .smps-article { flex: 1; min-width: 0; }

  .smps-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .smps-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
    
  .smps-meta-item:last-child { border-right: none; padding-right: 0; }
  .smps-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .smps-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .smps-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .smps-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .smps-article-body p { margin-bottom: 20px; }
  .smps-article-body p:last-child { margin-bottom: 0; }

  .smps-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .smps-article-body ol {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: smps-counter;
  }
  .smps-article-body ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: smps-counter;
  }
  .smps-article-body ol li::before {
    content: counter(smps-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .smps-article-body ol li > span { flex: 1; }

  .smps-article-body strong { font-weight: 600; color: #202020; }

  .smps-red-link {
    color: #EB2019; text-decoration: underline; font-weight: 600;
    display: block; margin-bottom: 20px;
  }
  .smps-red-link:hover { opacity: 0.8; }

  .smps-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .smps-red-link-plain:hover { opacity: 0.8; }

  .smps-plain-underline { text-decoration: underline; font-weight: 400; color: #202020; }

  /* Hashtags */
  .smps-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .smps-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .smps-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .smps-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .smps-nav-btn:hover { color: #EB2019; }
  .smps-nav-btn img { width: 40px; height: 40px; display: block; }

  .smps-share-icons { display: flex; align-items: center; gap: 20px; }
  .smps-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .smps-share-icon:hover { opacity: 0.85; }
  .smps-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .smps-sidebar { flex: 0 0 475px; }
  .smps-sidebar-block { margin-bottom: 60px; }
  .smps-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .smps-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .smps-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .smps-recent-item:hover .smps-recent-title { color: #EB2019; }
  .smps-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .smps-recent-body { flex: 1; min-width: 0; }
  .smps-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .smps-social-icons { display: flex; align-items: center; gap: 30px; }
  .smps-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .smps-social-icon:hover { opacity: 0.8; }
  .smps-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .smps-hero             { height: 350px; }
    .smps-hero-content     { padding: 0 32px; }
    .smps-hero-title       { font-size: 30px; }
    .smps-hero-divider     { width: 100%; max-width: 479px; }
    .smps-breadcrumb       { padding: 24px 0 0 0; }
    .smps-breadcrumb-inner { padding: 0 32px; }
    .smps-inner            { padding: 0 32px; }
    .smps-main-section     { padding: 48px 0 60px 0; }
    .smps-main-row         { flex-direction: column; gap: 48px; }
    .smps-sidebar          { flex: none; width: 100%; }
    .smps-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .smps-hero             { height: 360px; }
    .smps-hero-content     { padding: 0 16px; }
    .smps-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .smps-hero-divider     { width: 100%; }
    .smps-hero-subtitle    { font-size: 14px; }
    .smps-breadcrumb       { padding: 30px 0 0 0; }
    .smps-breadcrumb-inner { padding: 0 16px; }
    .smps-bc-item          { font-size: 14px; gap: 14px; }
    .smps-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .smps-bc-sep img       { width: 22px; height: 22px; }
    .smps-inner            { padding: 0 16px; }
    .smps-main-section     { padding: 30px 0 60px 0; }
    .smps-main-row         { flex-direction: column; gap: 60px; }
    .smps-sidebar          { flex: none; width: 100%; }
    .smps-article-title    { font-size: 20px; margin-bottom: 15px; }
    .smps-article-body     { font-size: 14px; }
    .smps-article-body p   { margin-bottom: 15px; }
    .smps-article-body ol  { margin: 20px 0 20px 0; gap: 20px; }
    .smps-article-body ol li { font-size: 14px; }
    .smps-article-body strong { font-size: 16px; }
    .smps-meta-item        { font-size: 14px; }
    .smps-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .smps-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .smps-hashtags         { margin-top: 30px; font-size: 14px; }
    .smps-nav-btn img      { width: 24px; height: 24px; }
    .smps-nav-btn          { font-size: 14px; }
    .smps-share-icon img   { width: 34px; height: 34px; }
    .smps-sidebar-title    { font-size: 20px; }
    .smps-bottom-nav       { gap: 20px; }
    .smps-meta-item:nth-child(2) { border-right: none; padding-right: 15px; }
  }
`;

const recentPosts = [
       {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function SwitchModePowerSupplyESP() {
  return (
    <div className="smps">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="smps-hero">
        <img className="smps-hero-bg" src={HeroBgImg} alt="Switch Mode Power Supply ESP Hero" />
        <div className="smps-hero-overlay" />
        <div className="smps-hero-content">
          <h1 className="smps-hero-title">
            Switch Mode Power Supply in Emission Control Systems: A Key Component for Electrostatic Precipitators in Coal-Fired Power Plants
          </h1>
          <hr className="smps-hero-divider" />
          <p className="smps-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="smps-breadcrumb" aria-label="Breadcrumb">
        <div className="smps-breadcrumb-inner">
          <a href="/" className="smps-bc-item">Home</a>
          <span className="smps-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="smps-bc-item">News &amp; Updates</a>
          <span className="smps-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="smps-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="smps-main-section">
        <div className="smps-inner">
          <div className="smps-main-row">

            {/* ── ARTICLE ── */}
            <article className="smps-article">

              {/* Meta bar */}
              <div className="smps-meta-bar">
                <span className="smps-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="smps-meta-item"><img src={CalendarIcon} alt="date" /> October 4, 2024</span>
                <span className="smps-meta-item"><img src={ClockIconImg} alt="time" /> 5:37 am</span>
                <span className="smps-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="smps-article-title">
                Switch Mode Power Supply in Emission Control Systems: A Key Component for Electrostatic Precipitators in Coal-Fired Power Plants
              </h1>

              {/* Body */}
              <div className="smps-article-body">

                <p>Emission control is crucial for decreasing air pollution, significantly reducing harmful pollutants released into the atmosphere. It also complies with environmental regulations for coal-fired power plants. One of the most efficient technologies for catching particulate matter from flue gases is the <a href="/electrostatic-precipitator" className="smps-red-link-plain">electrostatic precipitator</a> (ESP). At the core of these systems is the switch-mode power supply (SMPS), which is vital to ensure the effective operation of ESPs.</p>

                {/* Article image */}
                <img className="smps-article-img" src={ArticleImg} alt="Switch Mode Power Supply in Emission Control Systems" />

                <p>This article will explore the significance of SMPS in emission control systems and how it improves the <strong>implementation of electrostatic precipitators</strong> in coal-fired power plants.</p>

                <p>Let's dive in!</p>

                <ol>
                  <li><span><strong>What is Switch Mode Power Supply (SMPS)?</strong><br />
                  It is an efficient power conversion system. Unlike traditional power supplies, this system utilizes switching regulators to transform electrical power from one form to another. SMPS functions at higher frequencies, converting electrical energy more efficiently. This conversion makes SMPS standard for applications needing constant power output with the tiniest energy loss, such as <a href="/electrostatic-precipitators" className="smps-red-link-plain">electrostatic precipitators</a>.<br /><br />
                  In coal-fired power plants, ESPs release particulate matter, such as ash and soot, from flue gases before they enter the atmosphere. It delivers the high-voltage direct current (DC) needed to power the ESP's charging electrodes, assuring efficient particle accumulation.</span></li>

                  <li><span><strong>Enhancing Efficiency with SMPS</strong><br />
                  The efficiency of ESPs instantly affects the emission control systems of coal-fired power plants. An efficient ESP assures that up to 99% of particulate matter is extracted from the flue gases, significantly decreasing toxic emissions. The SMPS improves this method by delivering a steady and accurate power supply to the ESP, minimizing energy failures and enhancing the system's all-around performance.<br /><br />
                  SMPS provides very high energy conversion efficiency compared to conventional power supplies, so heat dissipation is generated to a minimal extent. This results in decreased energy consumption by the plant and increases equipment life. This efficiency improves the cost-effectiveness and carbon footprint of a coal power plant.</span></li>

                  <li><span><strong>Ensuring Reliability and Stability</strong><br />
                  One key benefit of using a SMPS in electrostatic precipitators is the reliability and stability it brings to the system. ESPs require a continuous and regulated high-voltage DC supply to function effectively. Fluctuations in power can reduce particle collection efficiency or even damage the ESP components.<br /><br />
                  SMPS assures a constant power output, even in irregular environmental circumstances. This solidity is necessary in coal-fired power plants, where the need for emission control is steady, and any downtime or inefficiency could result in improved emissions and regulatory liabilities.</span></li>

                  <li><span><strong>Lowering Environmental Impact</strong><br />
                  Combining <strong>switch-mode power supply</strong> (SMPS) in ESPs is crucial in lowering the environmental effect of coal-fired power plants. SMPS enables coal plants to fulfill stringent emissions standards by maximizing particle collection efficiency. This integration helps the environment by decreasing pollutants and allows power plants to bypass bulky fines and probable shutdowns due to non-compliant regulations.</span></li>
                </ol>

                <span className="smps-h2">Wrapping Up</span>

                <p>The <strong>switch mode power supply</strong> (SMPS) is an integral element in the emission control systems of coal-fired power plants. By improving the performance of <a href="/electrostatic-precipitators" className="smps-red-link-plain">electrostatic precipitators</a>, SMPS ensures efficient particulate matter collection, reduces energy consumption, and supports plants in meeting environmental regulations.</p>

                <p>SMPS operates at a high frequency, significantly enhancing efficiency compared to a linear power supply. By utilizing DC converters, such as buck converters, it effectively manages input and output power while maintaining a power factor corrected system. The switching frequency plays a crucial role in determining efficiency and overall performance.</p>

                <p>Key components such as the primary winding and secondary winding influence the turns ratio, which helps regulate input voltage and output voltage for optimal ESP operation. High-quality SMPS technology ensures reliable power conversion, improving overall <a href="/emission-control-system" className="smps-plain-underline">emission control system</a> and plant efficiency.</p>

                <p>Investing in advanced SMPS solutions is essential for coal-fired power plants aiming to optimize their emission control systems and achieve regulatory compliance.</p>

                <p><strong>Ador Powertron</strong> delivers cutting-edge <strong>switch mode power supply systems</strong> devised to maximize ESPs efficiencies.</p>

                <p>Are you looking to enhance your plant's performance?</p>

                <a href="/contact-us" className="smps-red-link">Contact us Now !</a>

                <p>With over 20,000+ High-Voltage Transformer-Rectifier units supplied and 200+ satisfied customers over the past 35 years, ADOR has established a strong footprint within the Power, Cement, Steel, Pulp, and Paper industries across 82 countries spanning six continents.</p>

                <p>ADOR T/Rs use software developed in-house, and it can also incorporate OEM software for managing and controlling the ESP. Its systems efficiently handle AC input and DC output using advanced linear regulators and buck-boost converters to optimize performance. The technology leverages transistor switching and precise duty cycle adjustments to ensure stable and efficient operation from the DC source.</p>

                <p>ADOR remains committed to investing in these areas and will continue to research innovative solutions to fight pollution and promote sustainable energy. To achieve this goal, Ador has a strategic technology-sharing partnership with Redkoh, the world's foremost precipitator controls company.</p>

                <p className="smps-hashtags"><strong>#SwitchModePowerSupply #ElectrostaticPrecipitators #EmissionControl #CoalFired #PowerPlants #EnergyEfficiency #Environmentallaws #compliance</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="smps-bottom-row">
                <div className="smps-bottom-nav">
                  <a href="/news/maximizing-efficiency-esp-coal" className="smps-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/transformer-rectifiers-coal-power" className="smps-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="smps-share-icons">
                  <a href="#" className="smps-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="smps-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="smps-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="smps-sidebar">

              {/* Recent Posts */}
              <div className="smps-sidebar-block">
                <p className="smps-sidebar-title">Recent Posts</p>
                <div className="smps-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="smps-recent-item">
                      <img src={post.img} alt={post.title} className="smps-recent-img" />
                      <div className="smps-recent-body">
                        <span className="smps-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="smps-sidebar-block">
                <p className="smps-sidebar-title">Social Media</p>
                <div className="smps-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="smps-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="smps-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}